const SiteHeader = {
  init (Headroom) {

    /*
    * Site Header - headroom js
    */

    if ( jQuery('.c-site-header').length ) {

      // grab an element
      var myElement = document.querySelector(".c-site-header");
      // construct an instance of Headroom, passing the element
      var headroom  = new Headroom(myElement, {
      });

      // initialise
      headroom.init();
    }

  }
};

export default SiteHeader;
